import * as React from 'react';
import JSONController from './JSONController';
class FetchJSON extends React.Component {
    constructor() {
        super(...arguments);
        this.jsonController = new JSONController();
        this.responseCache = new Map();
    }
    componentDidMount() {
        this.loadData();
    }
    componentDidUpdate(prevProps) {
        const { url, onResponse } = this.props;
        if (url !== prevProps.url) {
            if (this.responseCache.has(url)) {
                onResponse(this.responseCache.get(url));
            }
            else {
                this.loadData();
            }
        }
    }
    componentWillUnmount() {
        this.jsonController.abort();
    }
    loadData() {
        const { url, onError } = this.props;
        this.jsonController
            .fetch(url)
            .then((response) => {
            const { onResponse } = this.props;
            this.responseCache.set(url, response);
            onResponse(response);
        })
            .catch((error) => {
            onError != null ? onError(error) : console.error(error);
        });
    }
    render() {
        return null;
    }
}
export default FetchJSON;
